import { render, staticRenderFns } from "./live-old.vue?vue&type=template&id=39e93ec0&scoped=true&"
import script from "./live-old.vue?vue&type=script&lang=js&"
export * from "./live-old.vue?vue&type=script&lang=js&"
import style0 from "./live-old.vue?vue&type=style&index=0&id=39e93ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e93ec0",
  null
  
)

export default component.exports